import React from 'react';

import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Icon from '~/components/base/Icon';

import { dynamicFontSize } from '~/utilities/helpers';
import { transition } from '~/styles/transition';
import { srOnly } from '~/styles/helpers';

const Link = styled.button`
    display: inline-block;
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.medium};
    font-size: ${dynamicFontSize(1.4, 1.7, 2.1)};
    color: ${({ theme }) => theme.colors.text.blue};
    padding: 0;
    border: none;
    background-color: transparent;
    cursor: pointer;
    text-decoration: underline;
    ${transition({}, 'color')};

    svg * {
        ${transition({}, 'color')};
    }

    &:hover,
    &:focus {
        color: ${({ theme }) => theme.colors.primary.yellow};

        svg * {
            color: ${({ theme }) => theme.colors.primary.yellow};
        }
    }
`;

const StyledIcon = styled(Icon)`
    margin-right: 5px;
    margin-bottom: 3px;
    vertical-align: middle;
`;

const Text = styled.span`
    ${({ iconOnly }) => (iconOnly ? srOnly : '')};
`;

const UnderlineButton = ({
    children,
    onClick,
    icon = null,
    iconSize = 13,
    iconSizeMobile = 18,
    className = '',
    iconOnly = false,
    ...props
}) => {
    return (
        <Link {...{ onClick, className }} {...props}>
            {icon && (
                <StyledIcon
                    {...{ icon }}
                    size={iconSize}
                    sizeMobile={iconSizeMobile}
                    color="blue"
                />
            )}
            <Text {...{ iconOnly }}>{children}</Text>
        </Link>
    );
};

UnderlineButton.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.string,
    iconSize: PropTypes.number,
    iconSizeMobile: PropTypes.number,
    iconOnly: PropTypes.bool
};

export default UnderlineButton;
